import React from 'react';
import type { BlockStats } from 'types/block-stats';

import { Wrap, Paragraph, Heading, Card } from '@leafwell/components';

const Stats: React.FC<BlockStats> = ({ title, titleSize, items }) => (
  <Wrap size="large" spacer={false}>
    <Card
      variant="light"
      filled={false}
      rounded={false}
      size="large"
      className="border-0 grid grid-cols-3 md:grid-cols-5 lg:grid-cols-6 p-0 md:p-6"
    >
      {titleSize === 'small' ? (
        <Paragraph
          size="small"
          tagName="h3"
          className="font-medium col-span-full md:col-span-2 lg:col-span-3"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      ) : (
        <Heading
          level="5"
          className="font-sans font-medium col-span-full md:col-span-2 lg:col-span-3"
        >
          {title}
        </Heading>
      )}
      {items?.map(({ label, value }) => {
        return (
          <article className="justify-center">
            <Heading level="3">{value}</Heading>
            <Paragraph className="pt-1 font-thin" size="small">
              {label}
            </Paragraph>
          </article>
        );
      })}
    </Card>
  </Wrap>
);

export default Stats;
